import React from 'react';

import Error from '@common/components/Error';
import StyledError from './styled/Error';
import RequiredIndicator from './styled/RequiredIndicator';
import InputWrapper from './styled/FieldWrapper';
import { Label } from '../Typography';
import StyledTextarea from './styled/StyledTextarea';
import asReduxFormField from './asReduxFormField';

export const TextArea = ({
  isRequired = false,
  label,
  labelWidth = '100px',
  requiredLabelWidth = '20%',
  error,
  input,
  ...props
}) => (
  <InputWrapper>
    <Label width={labelWidth}>{label}</Label>

    {RequiredIndicator({
      requiredLabelWidth,
      isRequired,
      desktopOnly: false,
      mobileOnly: true,
    })}
    <StyledTextarea {...props} {...input} />
    {!!error && (
      <StyledError width={requiredLabelWidth}>
        <Error error={error} isFieldError={false} />
      </StyledError>
    )}

    {!error &&
      RequiredIndicator({
        requiredLabelWidth,
        isRequired,
        desktopOnly: true,
        mobileOnly: false,
      })}
  </InputWrapper>
);

export const TextareaField = asReduxFormField(TextArea);
